<app-loader></app-loader>
<div dir="{{ 'direction' | translate}}">

  @if (isROKMCST()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" languageOptions='[{ "code": "en"},{ "code": "ko"}]'
      applicationName="{{ 'navbar.isMCSTappName' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if (isDomain()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" languageOptions='[{ "code": "en"}]'
      applicationName="{{ 'navbar.isDomainappName' | translate }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

    @if (unAuthorizedUse()) {
     <!-- Disabled in production by unAuthorizedUse() logic -->
     <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage"
      languageOptions='[{ "code": "en"}, { "code": "es"}, { "code": "fr"}]'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if (isPrivate() && officeLoad) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" [languageOptions]='privateOfficeLanguage'
      applicationName="{{ navbarAppname | translate }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if ((isADR() || isADRYoung() || isPageNotFound() ) && !isUnilateralExpertRequest() && !isExpertRequest() && navbarVisible && !unAuthorizedUse()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage"
      languageOptions='[{ "code": "en"}, {"code": "es"}, {"code": "fr"}, {"code": "ru"}, {"code": "zh"}, {"code": "ar"}]'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if (isUnilateralExpertRequest()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" languageOptions='[{ "code": "en"}, {"code": "es"}, {"code": "fr"}, {"code": "zh"}]'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if (isExpertRequest()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" languageOptions='[{ "code": "en"},{"code": "zh"}]'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }

  @if (!isPrivate() && isCase()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" [languageOptions]='officeCaseLanguage'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory'>
    </wipo-navbar>
  }


  @if (isDCTI()) {
    <wipo-navbar appId='app-0022' [attr.pagekey]='pageKey' [applicationLink]='appLink'
      [language]="languageService.currentLanguage" languageOptions='[{ "code": "en"}, {"code": "es"}]'
      applicationName="{{ 'navbar.appname' | translate: {value: navbarTitle} }}" [helpOptions]="contactUsOptions"
      [applicationCategory]='appCategory' [customBreadcrumbs]='DCTIBreadcrumb'>
    </wipo-navbar>
  }

  <step>
    <f-facet name="step-info">
      @if (isADR()) {
        <w-sticky-bar [sticky]="sticky">
          <w-sticky-bar-link label="{{'ipportalDefault.mediation.pageName' | translate}}"
            [routerLink]="linkadrMediation"></w-sticky-bar-link>
          <w-sticky-bar-link label="{{'ipportalDefault.unilateralRequest.pageName' | translate}}"
            [routerLink]="linkadruniteralL"></w-sticky-bar-link>
          <w-sticky-bar-link label="{{'ipportalDefault.requestArbitration.pageName' | translate}}"
            [routerLink]="linkadrarbitration"></w-sticky-bar-link>
          <w-sticky-bar-link label="{{'ipportalDefault.expeditedArbitration.pageName' | translate}}"
            [routerLink]="linkadrexpedited"></w-sticky-bar-link>
          @if (languageService.currentLanguage === 'en' || languageService.currentLanguage === 'zh' ) {
            <w-sticky-bar-link label="{{'ipportalDefault.expertRequest.pageName' | translate}}"
              [routerLink]="linkadrexpert"></w-sticky-bar-link>
          }
          @if (languageService.currentLanguage === 'en' || languageService.currentLanguage === 'zh' || languageService.currentLanguage === 'es' || languageService.currentLanguage === 'fr') {
            <w-sticky-bar-link label="{{'ipportalDefault.unilateralExpertRequest.pageName' | translate}}"
              [routerLink]="linkadruniexpert"></w-sticky-bar-link>
          }
          <w-sticky-bar-link label="{{'ipportalDefault.requestForGoodOffices.pageName' | translate}}"
            [routerLink]="linkadrgoodOffice"></w-sticky-bar-link>
          @if (languageService.currentLanguage === 'en' || languageService.currentLanguage === 'es' || languageService.currentLanguage === 'fr' ) {
            <w-sticky-bar-link label="{{'ipportalDefault.noticeOfUnauthorizedUse.pageName' | translate}}"
              [routerLink]="linkadrNoticeUnauthorized"></w-sticky-bar-link>
          }
        </w-sticky-bar>
      }

      @if (isROKMCST()) {
        <w-sticky-bar [sticky]="sticky">
          <w-sticky-bar-link [label]="'mcstForm.tree.pageName' | translate"
            [routerLink]="linkrokMCST"></w-sticky-bar-link>
          <w-sticky-bar-link [label]="'mcstForm.mediation.pageName' | translate"
            [routerLink]="linkMediation"></w-sticky-bar-link>
          <w-sticky-bar-link [label]="'mcstForm.unilateralRequest.pageName' | translate"
            [routerLink]="linkUnilateral"></w-sticky-bar-link>
          <w-sticky-bar-link [label]="'mcstForm.requestForGoodOffices.pageName' | translate"
            [routerLink]="linkgoodOffices"></w-sticky-bar-link>
        </w-sticky-bar>
      }
    </f-facet>
  </step>

  <router-outlet></router-outlet>

</div>
